
import commonTable from './components/common-table'

export default {  
  layout: 'base',
  props: [],
  components: { 
    commonTable   
  },
  computed: {
    dname() {
        return this[`sub${this.tabRootActive}`][this.tabActive]['label']
    },
  },
  data() {
    return {
        isFinite: 1,
        tabRootActive: 0,
        tabActive: 0,
        columns: [],
        list: [],
        sub0: [             
             {
                label: '经济月报',
                url: '29200_03302387/1'
             },
             {
                label: '工业经济效益月报',
                url: '29200_03302374/1/'
             },
             {
                label: '工业统计月报',
                url: '29200_03302373/1/'
             },
             {
                label: '固定资产投资月报',
                url: '29200_03302375/1/'
             },
             {
                label: '对外贸易月报',
                url: '29200_03302379/1/'
             },
             {
                label: '物价月报',
                url: '29200_03302383/1/'
             },
             {
                label: '财政金融月报',
                url: '29200_03302382/1/'
             },
             {
                label: '旅游月报',
                url: '29200_03302381/1/'
             },
             {
                label: '外商直接投资月报',
                url: '29200_03302380/1/'
             },
             
             {
                label: '运输月报',
                url: '29200_03302377/1/'
             },
             {
                label: '商品房建设月报',
                url: '29200_03302376/1/'
             },
             {
                label: '国民经济核算',
                url: '29200_03302370/1/'
             }
        ],
        sub1: [
             {
                label: '经济月报',
                url: '29200_03302385/1'
             },
            {
                label: '年度分区生产总值',
                url: '29200_03302385/1/'
            }
        ],
        sub2: [
            {
                label: '战略新兴产业月报',
                url: '29200_03302386/1/'
            },
            {
                label: '产业链全景图',
                url: '/common/getIndustryReports1'
            },
            {
                label: '行业研报',
                url: '/common/getIndustryReports'
            }
        ],

    }
  },
  mounted() {
    this.checkItem()
  },
  methods: {
    checkItem(rootIndex = 0, index = 0) {
        this.tabRootActive = rootIndex
        this.tabActive = index
        this.getThirdData(this[`sub${this.tabRootActive}`][this.tabActive]['url'])
    },
    async getThirdData(route) {             
      this[`changeColumns${this.tabRootActive}`](this.tabActive)  
          
      await this.$refs.commonTable.getTotal(route)           
    },
    changeColumns0(n) {
        switch (Number(n)) {            
            case 0:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  },
                  {
                    type: 'ND',
                    label: '年度'
                  },
                  {
                    type: 'BSN',
                    label: '比上年'
                  }
                ]
                break;
            case 1:                    
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  },
                  {
                    type: 'BYZLJ',
                    label: '本月止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  }
                ]
                break 
            case 2:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  },
                  {
                    type: 'BENYUE',
                    label: '本月'
                  },
                  {
                    type: 'BYZLJ',
                    label: '本月止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  }
                ]
                break 
              case 3:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  },
                  {
                    type: 'BYZLJ',
                    label: '本月止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  } 
                ]
                break 
            
            case 4:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  },
                  {
                    type: 'RZDBYWJYXKZBH',
                    label: '融资担保业务许可证编号'
                  },
                  {
                    type: 'BENYUE',
                    label: '本月'
                  },
                  {
                    type: 'BYZLJ',
                    label: '本月止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  }
                ]
                break
              
              case 5:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'BENYUE',
                    label: '本月'
                  },
                  {
                    type: 'BYZLJPJ',
                    label: '本月止累计平均'
                  }
                ]
                break


                case 6:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    width: 160,
                    isAlign: true,
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  },
                  {
                    type: 'BENYUE',
                    label: '本月'
                  },
                  {
                    type: 'CZBYZLJ_JRSNTYYE',
                    label: '财政：本月止累计/金融：上年同月余额'
                  },
                  {
                    type: 'CZLJTB_JRTBZC',
                    label: '财政：累计同比/金融：同比增长'
                  }
                ]
                break

                 case 7:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  }

                  ,
                  {
                    type: 'BENYUE',
                    label: '本月'
                  },
                  {
                    type: 'BYZLJ',
                    label: '本月止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  }
                ]
                break

                case 8:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  }

                  ,
                  {
                    type: 'BENYUE',
                    label: '本月'
                  },
                  {
                    type: 'BYZLJ',
                    label: '本月止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  }
                ]
                break

                case 9:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  }

                  ,
                  {
                    type: 'BENYUE',
                    label: '本月'
                  },
                  {
                    type: 'BYZLJ',
                    label: '本月止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  }
                ]
                break

                case 10:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  }

                  ,
                  {
                    type: 'BYZLJ',
                    label: '本月止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  }
                ]
                break

                case 11:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  }

                  ,
                  {
                    type: 'BNBJD',
                    label: '本年本季度'
                  },
                  {
                    type: 'BNBJDZLJ',
                    label: '本年本季度止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  }
                ]
                break
            default: 
                this.columns = this.columns
                break          
        }
    },

    changeColumns1(n) {
        switch (Number(n)) {  
                 
            case 0:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  },
                  {
                    type: 'DQSCZZ_BJZLJJDZ',
                    label: '地区生产总值——本季止累计绝对值'
                  },
                  {
                    type: 'DQSCZZ_BJZLJTB',
                    label: '地区生产总值——本季止累计同比'
                  },
                  {
                    type: 'GMYSGYZJZ_BYZLJTB',
                    label: '规模以上工业增加值——本月止累计绝对值'
                  },
                  {
                    type: 'GDZCTZE_BYZLJJDZ',
                    label: '固定资产投资额——本月止累计绝对值'
                  },
                  {
                    type: 'GDZCTZE_BYZLJTB',
                    label: '固定资产投资额——本月止累计同比'
                  },
                  {
                    type: 'SHXFPLSZE_BYZLJJDZ',
                    label: '社会消费品零售总额——本月止累计绝对值'
                  },
                  {
                    type: 'SHXFPLSZE_BYZLJTB',
                    label: '社会消费品零售总额——本月止累计同比'
                  }
                ]
                break;
            case 1:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  },
                  {
                    type: 'ND',
                    label: '年度'
                  },
                  {
                    type: 'BSN',
                    label: '比上年'
                  }
                ]
                break;   
            default: 
                this.columns = this.columns
                break          
        }
    },


    changeColumns2(n) {
        switch (Number(n)) {            
            case 0:                
                this.columns = [
                  {
                    type: 'NY',
                    label: '年月'
                  },
                  {
                    type: 'ZBMC',
                    label: '指标名称'
                  },
                  {
                    type: 'DW',
                    label: '单位'
                  },
                  {
                    type: 'BJZLJ',
                    label: '本季止累计'
                  },
                  {
                    type: 'LJTB',
                    label: '累计同比'
                  }
                ]
                break;
            default: 
                this.columns = this.columns
                break          
        }
    },
  }
}
